import { AccountNavLink } from '~/techstyle-shared/react-builder-models';

export const BuilderAccountNavLinkConfig = {
  ...AccountNavLink,
};
